<template>
  <span class="ro__checkbox">
    <b-icon-check-square-fill v-if="checked"/>
    <b-icon-square v-else/>
  </span>
</template>

<style lang="scss" scoped>
  @use "../app.scss";

  .ro__checkbox {
    margin-right: 0.25rem;
    color: app.$vnpt-blue-color;
  }
</style>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class ReadOnlyCheckBox extends BaseComponent {

    @Prop({ default: true }) checked: boolean;

    mounted() {

    }

  }
</script>
